// Interfaces and types
import { ISignResWhenNeedTwoFactorCode } from 'types/authTypes';

export interface IStorageData {
  accessToken?: ISignResWhenNeedTwoFactorCode['sessionToken'];
  clientStatusIds?: number[];
}

interface IStorage {
  getData: <T = IStorageData>(key?: string) => T;
  setData: <T = IStorageData>(data: T, key?: string) => void;
  unsetData: (key?: string) => void;
}

const storage: IStorage = {
  getData(key = 'timeGo') {
    const data = sessionStorage.getItem(key) || '{}';
    return JSON.parse(data);
  },

  setData(data, key = 'timeGo') {
    sessionStorage.setItem(key, JSON.stringify(data));
  },

  unsetData(key = 'timeGo') {
    sessionStorage.removeItem(key);
  },
};

export default storage;
